import { useEffect, useMemo, useState } from "react";
import { GeoJSON, Marker, Pane, Polyline, Tooltip } from "react-leaflet";
import { useAppSelector } from "Hooks/useRedux";
import { HeatmapLayerFactory } from "@vgrid/react-leaflet-heatmap-layer";
import useTraffic from "Hooks/useTraffic";

const HeatmapLayer = HeatmapLayerFactory<[number, number, number]>();

const ICON_SIZE = 22;

export default function TrafficHeatMap() {
  const { visible } = useAppSelector((state) => state.traffic);
  const { survayLayer } = useAppSelector((state) => state.layers);
  const { zone } = useAppSelector((state) => state.zones);

  const { data } = useTraffic();

  const [heatMapData, setHeatMapData] = useState<[number, number, number][]>([]);

  const handleHeatMap = (dat: any) => {
    const dataTemp = [];
    for (let i = 0; i < dat?.length; i += 1) {
      const temp: [number, number, number] = [1, 1, 1];
      if (dat[i].TTO_Data) {
        const traffic = JSON.parse(`{${dat[i].TTO_Data}}`);
        temp[0] = traffic.GeographicalAccident;
        temp[1] = traffic.GeographicalLength;
      }
      dataTemp.push(temp);
    }
    setHeatMapData(dataTemp);
  };

  const makeGradient = () => {
    return {
      0.1: "#cdfc9e",
      0.3: "#76c52b",
      0.5: "#5d910c",
      0.6: "#cad004",
      0.8: "#c6a006",
      1: "#d67540",
    };
  };

  useEffect(() => {
    handleHeatMap(data);
  }, [data]);

  if (!visible) return <></>;
  return (
    <>
      <Pane name="show_traffic_heatmap" style={{ zIndex: survayLayer }} key={`${zone}${survayLayer}`}>
        <HeatmapLayer
          points={heatMapData}
          longitudeExtractor={(m) => m[1]}
          latitudeExtractor={(m) => m[0]}
          intensityExtractor={(m) => m[2]}
          minOpacity={0.2}
          max={2}
          radius={20}
          opacity={1}
          blur={10}
          gradient={makeGradient()}
        />
      </Pane>
    </>
  );
}
